import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

/**
 * Quản lý whitelist email được phép đăng nhập web quản trị.
 *
 * Tài khoản thuộc domain công ty (inmobivn.com) luôn đăng nhập được nên server từ
 * chối thêm vào đây — danh sách này chỉ dành cho email lẻ ngoài domain.
 *
 * API yêu cầu role CUSTOMER-SUPPORTER trở lên (CUSTOMER-SUPPORTER / ICOIN-MANAGER /
 * MANAGER); axios đã gắn sẵn header Authorization (authToken.js).
 */
export default class LoginWhitelistPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            assignableRoles: [],
            email: "",
            note: "",
            // email -> role đang chọn trong dropdown ở bảng (chưa lưu)
            roleDraft: {},
            loadingList: false,
            loadingAdd: false,
            removingEmail: null,
            assigningEmail: null,
        };
    }

    componentDidMount() {
        this.loadList();
    }

    loadList = () => {
        this.setState({ loadingList: true });

        axios
            .get(`${global.config.apiDomain}/rest/login-whitelist/list`)
            .then((res) => {
                this.setState({ loadingList: false });
                const data = res.data || {};
                if (data.status !== "OK") {
                    toast.error(data.message || "Không lấy được danh sách");
                    return;
                }
                const items = (data.data && data.data.items) || [];
                // Danh sách role lấy từ server để không lệch với ASSIGNABLE_ROLES.
                const assignableRoles =
                    (data.data && data.data.assignableRoles) || [];

                // Dropdown mỗi dòng khởi tạo theo role thực tế của tài khoản.
                const roleDraft = {};
                items.forEach((item) => {
                    roleDraft[item.email] = item.role || "";
                });

                this.setState({ items, assignableRoles, roleDraft });
            })
            .catch((error) => {
                this.setState({ loadingList: false });
                this.handleError(error, "Đã xảy ra lỗi khi lấy danh sách");
            });
    };

    handleAdd = (e) => {
        e.preventDefault();
        const { email, note } = this.state;

        if (!email || !email.trim()) {
            toast.warning("Vui lòng nhập email");
            return;
        }

        this.setState({ loadingAdd: true });

        axios
            .post(
                `${global.config.apiDomain}/rest/login-whitelist/add`,
                {
                    email: email.trim(),
                    note: (note || "").trim(),
                },
                { headers: { "Content-Type": "application/json" } }
            )
            .then((res) => {
                this.setState({ loadingAdd: false });
                const data = res.data || {};
                if (data.status !== "OK") {
                    toast.error(data.message || "Thêm email thất bại");
                    return;
                }
                toast.success(
                    "Đã thêm email. Gán role sau khi tài khoản đăng nhập lần đầu."
                );
                this.setState({ email: "", note: "" });
                this.loadList();
            })
            .catch((error) => {
                this.setState({ loadingAdd: false });
                this.handleError(error, "Đã xảy ra lỗi khi thêm email");
            });
    };

    handleAssignRole = (email) => {
        const role = this.state.roleDraft[email] || "";

        if (!role) {
            if (
                !window.confirm(
                    `Gỡ toàn bộ quyền quản trị của "${email}"?`
                )
            ) {
                return;
            }
        }

        this.setState({ assigningEmail: email });

        axios
            .post(
                `${global.config.apiDomain}/rest/login-whitelist/assign-role`,
                { email, role },
                { headers: { "Content-Type": "application/json" } }
            )
            .then((res) => {
                this.setState({ assigningEmail: null });
                const data = res.data || {};
                if (data.status !== "OK") {
                    toast.error(data.message || "Gán role thất bại");
                    return;
                }
                // Quyền nằm trong JWT cấp lúc đăng nhập, nên token hiện tại của user
                // vẫn mang role cũ cho tới khi họ lấy token mới.
                toast.success(
                    (role ? `Đã gán role ${role}. ` : "Đã gỡ quyền quản trị. ") +
                        "User cần đăng xuất và đăng nhập lại để áp dụng."
                );
                this.loadList();
            })
            .catch((error) => {
                this.setState({ assigningEmail: null });
                this.handleError(error, "Đã xảy ra lỗi khi gán role");
            });
    };

    handleRemove = (email) => {
        if (!window.confirm(`Xóa "${email}" khỏi whitelist?`)) {
            return;
        }

        this.setState({ removingEmail: email });

        axios
            .post(
                `${global.config.apiDomain}/rest/login-whitelist/remove`,
                { email },
                { headers: { "Content-Type": "application/json" } }
            )
            .then((res) => {
                this.setState({ removingEmail: null });
                const data = res.data || {};
                if (data.status !== "OK") {
                    toast.error(data.message || "Xóa email thất bại");
                    return;
                }
                toast.success("Đã xóa email khỏi whitelist");
                this.loadList();
            })
            .catch((error) => {
                this.setState({ removingEmail: null });
                this.handleError(error, "Đã xảy ra lỗi khi xóa email");
            });
    };

    handleError = (error, fallbackMessage) => {
        const status = error.response && error.response.status;
        if (status === 401) {
            toast.error("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại");
        } else if (status === 403) {
            toast.error("Bạn không có quyền MANAGER để dùng chức năng này");
        } else {
            toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    fallbackMessage
            );
        }
        console.error(fallbackMessage, error);
    };

    formatTime = (value) => {
        if (!value) return "";
        const date = new Date(value);
        return isNaN(date.getTime()) ? "" : date.toLocaleString();
    };

    render() {
        const {
            items,
            assignableRoles,
            email,
            note,
            roleDraft,
            loadingList,
            loadingAdd,
            removingEmail,
            assigningEmail,
        } = this.state;

        return (
            <div
                className="container-fluid"
                style={{ marginTop: "100px", marginBottom: "20px" }}
            >
                <div className="row">
                    <div className="col-md-10 offset-md-1">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-user-shield mr-2"></i>
                                    Whitelist email đăng nhập web quản trị
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-info">
                                    Tài khoản <strong>@inmobivn.com</strong> luôn đăng
                                    nhập được nên <strong>không thêm được</strong> vào
                                    đây. Danh sách này dành cho email{" "}
                                    <strong>ngoài domain công ty</strong> (ví dụ Gmail
                                    cá nhân, tài khoản test).
                                    <br />
                                    <strong>Role</strong> chỉ gán được sau khi tài khoản
                                    đã đăng nhập lần đầu (tài khoản được tạo ở thời điểm
                                    đó). Sau khi user đăng nhập, bấm <em>Tải lại</em> rồi
                                    chọn role ở cột Role trong bảng.
                                    <br />
                                    Gán role xong, <strong>user phải đăng xuất và đăng
                                    nhập lại</strong> thì quyền mới có hiệu lực (quyền nằm
                                    trong token đã cấp lúc đăng nhập).
                                </div>

                                <form
                                    className="form-row align-items-end mb-4"
                                    onSubmit={this.handleAdd}
                                >
                                    <div className="form-group col-md-5">
                                        <label htmlFor="email">
                                            <strong>Email *</strong>
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            value={email}
                                            onChange={(e) =>
                                                this.setState({ email: e.target.value })
                                            }
                                            placeholder="vidu@gmail.com"
                                            disabled={loadingAdd}
                                        />
                                    </div>
                                    <div className="form-group col-md-5">
                                        <label htmlFor="note">
                                            <strong>Ghi chú</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="note"
                                            value={note}
                                            onChange={(e) =>
                                                this.setState({ note: e.target.value })
                                            }
                                            placeholder="Lý do cấp quyền (không bắt buộc)"
                                            disabled={loadingAdd}
                                        />
                                    </div>
                                    <div className="form-group col-md-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block"
                                            disabled={loadingAdd}
                                        >
                                            {loadingAdd ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang thêm...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-plus mr-2"></i>
                                                    Thêm
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <strong>
                                        Danh sách ({items.length})
                                    </strong>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={this.loadList}
                                        disabled={loadingList}
                                    >
                                        <i className="fa-solid fa-rotate-right mr-1"></i>
                                        Tải lại
                                    </button>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: "24%" }}>Email</th>
                                                <th style={{ width: "20%" }}>
                                                    Trạng thái
                                                </th>
                                                <th style={{ width: "28%" }}>Role</th>
                                                <th style={{ width: "14%" }}>Ghi chú</th>
                                                <th style={{ width: "14%" }}>
                                                    Người thêm
                                                </th>
                                                <th style={{ width: "8%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadingList && (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        <span
                                                            className="spinner-border spinner-border-sm mr-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Đang tải...
                                                    </td>
                                                </tr>
                                            )}

                                            {!loadingList && items.length === 0 && (
                                                <tr>
                                                    <td
                                                        colSpan="6"
                                                        className="text-center text-muted"
                                                    >
                                                        Chưa có email nào trong whitelist
                                                    </td>
                                                </tr>
                                            )}

                                            {!loadingList &&
                                                items.map((item) => (
                                                    <tr key={item.email}>
                                                        <td>
                                                            {item.email}
                                                            <br />
                                                            <small className="text-muted">
                                                                {this.formatTime(
                                                                    item.addTime
                                                                )}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            {item.hasAccount ? (
                                                                <>
                                                                    <span className="badge badge-success">
                                                                        Đã đăng nhập
                                                                    </span>
                                                                    <div>
                                                                        <small className="text-muted">
                                                                            {
                                                                                item.accountName
                                                                            }
                                                                            {item.uid
                                                                                ? ` (uid ${item.uid})`
                                                                                : ""}
                                                                        </small>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <span className="badge badge-warning">
                                                                    Chờ đăng nhập lần đầu
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {item.hasAccount ? (
                                                                <div className="d-flex">
                                                                    <select
                                                                        className="form-control form-control-sm mr-1"
                                                                        value={
                                                                            roleDraft[
                                                                                item.email
                                                                            ] || ""
                                                                        }
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                roleDraft: {
                                                                                    ...roleDraft,
                                                                                    [item.email]:
                                                                                        e
                                                                                            .target
                                                                                            .value,
                                                                                },
                                                                            })
                                                                        }
                                                                        disabled={
                                                                            assigningEmail ===
                                                                            item.email
                                                                        }
                                                                    >
                                                                        <option value="">
                                                                            -- Không có
                                                                            quyền --
                                                                        </option>
                                                                        {assignableRoles.map(
                                                                            (r) => (
                                                                                <option
                                                                                    key={r}
                                                                                    value={r}
                                                                                >
                                                                                    {r}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </select>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() =>
                                                                            this.handleAssignRole(
                                                                                item.email
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            assigningEmail ===
                                                                            item.email
                                                                        }
                                                                    >
                                                                        {assigningEmail ===
                                                                        item.email ? (
                                                                            <span
                                                                                className="spinner-border spinner-border-sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            ></span>
                                                                        ) : (
                                                                            "Lưu"
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <small className="text-muted">
                                                                    Gán được sau khi user
                                                                    đăng nhập
                                                                </small>
                                                            )}
                                                        </td>
                                                        <td>{item.note || ""}</td>
                                                        <td>
                                                            {item.addedByName || ""}
                                                            {item.addedByUid ? (
                                                                <>
                                                                    <br />
                                                                    <small className="text-muted">
                                                                        uid{" "}
                                                                        {item.addedByUid}
                                                                    </small>
                                                                </>
                                                            ) : null}
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() =>
                                                                    this.handleRemove(
                                                                        item.email
                                                                    )
                                                                }
                                                                disabled={
                                                                    removingEmail ===
                                                                    item.email
                                                                }
                                                            >
                                                                {removingEmail ===
                                                                item.email ? (
                                                                    <span
                                                                        className="spinner-border spinner-border-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                ) : (
                                                                    <i className="fa-solid fa-trash"></i>
                                                                )}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
